import React from "react";
import { RecordContextType } from "../../components/record/Record";
import { getStore } from "../../store/store";
import { ROLES } from "../../utils/constants";
import { RecalculateScoresConfirmDialog } from "./components/RecalculateScoresConfirmDialog";
import { CancelResponseConfirmDialog } from "./components/CancelResponseConfirmDialog";

const CANCELLABLE_STATUSES = ["not_sent", "sent", "in_progress"];

export const psyEvaluationsActions = [
	{
		code: "recalculate_scores",
		name: "Recalcular Pontuações",
		actionFn: (context: RecordContextType) => openRecalculateScoresDialog(context),
		roles: [
			ROLES.tech_admin,
			ROLES.nfb_techncians,
			ROLES.neurofeedback_director,
			ROLES.theurapist,
			ROLES.technical_director,
			ROLES.admin,
			ROLES.shilan,
			ROLES.nfb_and_theurapist
		]
	},
	{
		code: "cancel_response",
		name: "Cancelar Questionário",
		actionFn: (context: RecordContextType) => openCancelResponseDialog(context),
		roles: [
			ROLES.tech_admin,
			ROLES.nfb_techncians,
			ROLES.neurofeedback_director,
			ROLES.theurapist,
			ROLES.technical_director,
			ROLES.admin,
			ROLES.shilan,
			ROLES.nfb_and_theurapist
		]
	}
];

const openRecalculateScoresDialog = (context: RecordContextType) => {
	const responseId = context?.item?.id;
	if (!responseId) throw Error("Resposta não encontrada.");

	const { appDialog } = getStore();
	appDialog.createDialog({
		title: "Recalcular Pontuações",
		contentAndActions: React.createElement(RecalculateScoresConfirmDialog, {
			responseId: String(responseId),
			onClose: () => appDialog.toggleIsOpen()
		}),
		allowSoftCancel: true
	});

	return { showSuccessMessage: "no" };
};

const openCancelResponseDialog = (context: RecordContextType) => {
	const responseId = context?.item?.id;
	if (!responseId) throw Error("Resposta não encontrada.");

	const status = context?.item?.status;
	if (!CANCELLABLE_STATUSES.includes(status))
		throw Error("Só é possível cancelar questionários em estado pendente (não enviado, enviado ou em progresso).");

	const { appDialog } = getStore();
	appDialog.createDialog({
		title: "Cancelar Questionário",
		contentAndActions: React.createElement(CancelResponseConfirmDialog, {
			responseId: String(responseId),
			onClose: () => appDialog.toggleIsOpen()
		}),
		allowSoftCancel: true
	});

	return { showSuccessMessage: "no" };
};
